<template>
  <div v-if="!minValueValid">
    <v-alert
      v-if="orderValue && valueDifference < 0"
      type="error"
      class="ma-0"
      outlined
      text
      >Minimum order value of £{{ orderValue.toFixed(2) }}, you must spend £{{
        Math.abs(valueDifference).toFixed(2)
      }}
      more to enable standing order</v-alert
    >
    <v-alert
      v-else-if="orderValue && valueDifference >= 0"
      outlined
      type="success"
      text
      class="ma-0"
      >Your Order Value is over the minimum of £{{
        orderValue.toFixed(2)
      }}</v-alert
    >
  </div>
</template>

<script>
export default {
  computed: {
    minValueValid() {
      if (this.$store.getters.retrieveStandingOrderTrolly) {
        if (
          Object.keys(
            this.$store.getters.retrieveStandingOrderTrolly.trolly_items
          ).length > 0
        ) {
          return this.$store.getters.retrieveStandingOrderTrolly
            .minimum_order_value.valid;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },

    orderValue() {
      if (this.$store.getters.retrieveStandingOrderTrolly) {
        if (
          Object.keys(
            this.$store.getters.retrieveStandingOrderTrolly.trolly_items
          ).length > 0
        ) {
          let minCheckoutValue = parseFloat(
            this.$store.getters.retrieveStandingOrderTrolly.minimum_order_value
              .minimumOrderValue
          );

          if (minCheckoutValue > 0) {
            return minCheckoutValue;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    valueDifference() {
      if (this.$store.getters.retrieveStandingOrderTrolly) {
        if (
          Object.keys(
            this.$store.getters.retrieveStandingOrderTrolly.trolly_items
          ).length > 0
        ) {
          let valueDifference = parseFloat(
            this.$store.getters.retrieveStandingOrderTrolly.totalValue
          );

          valueDifference -= parseFloat(
            this.$store.getters.retrieveStandingOrderTrolly.minimum_order_value
              .minimumOrderValue
          );

          return valueDifference;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
</style>